// Components==============
import Token from 'components/UI/Token/Token';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { ReflectContext } from 'pages/Growth/Reflect/Reflect';
import React, { useContext } from 'react';
import './CheckpointInfo.module.scss';
// =========================

export default function CheckpointInfo() {
  const { checkpointGroup, processes, checkpointGroups } = useContext(
    ReflectContext
  );

  const translate = useTranslate();

  const cardItem = checkpointGroup?.[checkpointGroup.length - 1];

  const startDescription = processes?.[0]?.description;

  const designQuestion =
    startDescription &&
    typeof startDescription !== 'string' &&
    'design_question' in startDescription
      ? startDescription.design_question
      : '';

  const checkPointToken = useRedux((state) =>
    cardItem?.process_type === 'App\\Activity'
      ? state.activity?.entities.byId[cardItem?.process_id]
      : undefined
  );

  const endPointToken = useRedux((state) =>
    cardItem?.process_type === 'App\\Phase'
      ? state.phase?.entities.byId[cardItem?.process_id]
      : undefined
  );

  const checkpointNumber =
    checkpointGroup && checkpointGroups.indexOf(checkpointGroup) + 1;

  return (
    <div styleName="wrapper">
      <div styleName="token">
        <Token token={checkPointToken || endPointToken} />
      </div>
      <div>
        <h3>{designQuestion}</h3>
        <p>
          {endPointToken
            ? translate('general.terms.end-point')
            : `${translate('project.terms.checkpoint')} ${checkpointNumber}`}
        </p>
      </div>
    </div>
  );
}
